import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const GarminEchomapUhd293sv = () => {
  console.log('🎯 GarminEchomapUhd293sv component loading');
  
  const product = findProductById("echomap-93sv-uhd2");
  
  if (!product) {
    console.error('Product not found:', "echomap-93sv-uhd2");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="echomap-93sv-uhd2"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default GarminEchomapUhd293sv; 